import { Component, OnInit, Type, ViewChild, ViewContainerRef, input, output, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-component-wrapper',
  template: '<ng-container #container />',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: true,
})
export class TableComponentWrapperComponent<T> implements OnInit {
  @ViewChild('container', { read: ViewContainerRef, static: true }) viewContainer: ViewContainerRef;
  readonly component = input<Type<T>>();
  readonly componentInit = output<T>();

  ngOnInit(): void {
    this.viewContainer.clear();

    const componentRef = this.viewContainer.createComponent(this.component());
    this.componentInit.emit(componentRef.instance);
  }
}
